/** Stable id for dashboard "Recent results" section (scroll / hash nav). */
export const DASHBOARD_RECENT_RESULTS_ID = 'dashboard-recent-results';

/** Stable id for dashboard "Upcoming matches" section (scroll / hash nav). */
export const DASHBOARD_UPCOMING_MATCHES_ID = 'dashboard-upcoming-matches';
